import { render, staticRenderFns } from "./FooterProductDocumentTable.vue?vue&type=template&id=47d390af&scoped=true&"
import script from "./FooterProductDocumentTable.vue?vue&type=script&lang=js&"
export * from "./FooterProductDocumentTable.vue?vue&type=script&lang=js&"
import style0 from "./FooterProductDocumentTable.vue?vue&type=style&index=0&id=47d390af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d390af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VIcon,VRow})
